import React, { useState } from "react";
import { StyleSheet } from "react-native";
import { Button } from "~/components/Button";
import { ErrorView } from "~/components/ErrorView";
import { Modal } from "~/components/Modal";
import { View } from "~/components/View";
import { styleConstants } from "~/style/styleConstants";
import { shadow } from "~/utils/shadow";
import { errorAlertContext } from "./errorAlertContext";

export const ErrorAlertProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [error, setError] = useState<unknown | undefined>(undefined);

  return (
    <>
      <errorAlertContext.Provider value={setError}>
        {children}
      </errorAlertContext.Provider>
      {!!error && (
        <Modal>
          <View style={StyleSheet.absoluteFill} colorBackgroundBackdrop />
          <View flex paddingExtraLarge justifyContentCenter>
            <View
              style={{
                backgroundColor: styleConstants.colorBackgroundLight,
                borderRadius: styleConstants.borderRadiusMedium,
                ...shadow(4),
              }}
            >
              <ErrorView error={error} />

              <View paddingExtraLarge>
                <Button
                  title={intl.formatMessage({
                    defaultMessage: "Continue",
                    id: "8isYGV",
                    description:
                      "Button on error alert modal that closes the modal",
                  })}
                  onPress={() => {
                    setError(undefined);
                  }}
                />
              </View>
            </View>
          </View>
        </Modal>
      )}
    </>
  );
};
